
import React, { createContext, useContext, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import AppContent from './AppContent';

const ThemeContext = createContext(null);
export const useTheme = () => useContext(ThemeContext);
const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState('light');
    return <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>;
};

function App() {
    return (
        <Router>
            <ThemeProvider>
                <AuthProvider>
                    <ErrorBoundary>
                        <AppContent />
                    </ErrorBoundary>
                </AuthProvider>
            </ThemeProvider>
        </Router>
    );
}

export default App;
